module.exports = __webpack_public_path__ + "img/usage-3.fcaeafc0.png";